var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wait",class:{ 'stretch-size-wrapper': _vm.stretchSizeValue },style:({
        width: _vm.computedWidth,
        paddingBottom: _vm.stretchSizeValue ? `${_vm.stretchSizeValue}%` : '',
    })},[_c('div',{staticClass:"lds-dual-ring",class:{ 'stretch-size': _vm.stretchSizeValue }})])
}
var staticRenderFns = []

export { render, staticRenderFns }